import { Box, Badge, Fab } from "@mui/material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

interface FloatingCartButtonProps {
  cartCount: number;
  onClick: () => void;
}
const FloatingCartButton : React.FC<FloatingCartButtonProps>= ({ cartCount, onClick }) => {
  return (
    <Box
    onClick={onClick}
      sx={{
        position: "fixed",
        bottom: 16,
        right: 20,
        zIndex: 9999,
      }}
    >
      <Badge
        badgeContent={cartCount}
        color="primary"
        overlap="circular" // ensures badge overlaps properly with circular Fab
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        sx={{
          position: 'relative',
          '& .MuiBadge-badge': {
            zIndex: 1,
          },
        }}
      >
        <Fab 
          color="secondary" 
          size="medium" 
          aria-label="cart"
          sx={{
            position: 'relative',
            zIndex: 0,
          }}
        >
          <ShoppingCartIcon />
        </Fab>
      </Badge>
    </Box>
  );
};

export default FloatingCartButton;
